import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyClx16R2zReQEyhDXmS9EOgV_vmx14vAO0",
    authDomain: "vetir-web.firebaseapp.com",
    projectId: "vetir-web",
    storageBucket: "vetir-web.appspot.com",
    messagingSenderId: "332809813919",
    appId: "1:332809813919:web:e8522bd07701495b1247aa",
    measurementId: "G-DNDJ2ZF86Q",
};

const firebaseConfigStag = {
    apiKey: "AIzaSyAQvorsh4alMA66eB1HS_lBx6BSDG9UKv4",
    authDomain: "vetir-web-stag.firebaseapp.com",
    projectId: "vetir-web-stag",
    storageBucket: "vetir-web-stag.firebasestorage.app",
    messagingSenderId: "1035732152691",
    appId: "1:1035732152691:web:8bc8b9f55a3d12590b5506",
    measurementId: "G-L7FVWWV0F5",
};

const app = initializeApp(process.env.EXPO_PUBLIC_ENV == "STAGING" ? firebaseConfigStag : firebaseConfig);

let analytics = null;
if (typeof window !== "undefined") {
    analytics = getAnalytics(app);
}

export { app, analytics };
